<script setup lang="ts">
import { useSlots } from "vue";
import { useVuelidate } from "@vuelidate/core";

useSlots();
withDefaults(defineProps<{
    col?: string
}>(), {
    col: "col-md-11",
});

const v$ = useVuelidate();

</script>

<template>
    <div
        :class="col"
    >
        <slot />
    </div>
    <div
        v-if="v$.$error"
        class="field-validation-error"
    >
        <div class="alert alert-danger">
            {{ v$.$errors[0].$message }}
        </div>
    </div>
</template>
